export default {
  title:
    'If you want go to waitless, you need confirm redirection to another tab in popup. After open waitless you can close this tab',
};
